import React, { Component } from "react";
import "./mainButton.css";

class MainButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: "Continuar",
      class: "main-button",
    };
  }

  componentDidMount() {
    let classStyle = this.props.class ? `${this.props.class} ${this.state.class}` : this.state.class;
    if(this.props.error){
      classStyle =  `${classStyle}-error`;
    }
    if(this.props.outline){
      classStyle = `${classStyle} outline`;
    }
    this.setState({
      text: this.props.text ?? this.state.text,
      class: classStyle
    });
  }

  render() {
    return (
        <button
          className={this.state.class}
          disabled={this.props?.disabled ?? false}
          onClick={this.props.onClick}
          type={this.props.type ?? 'button'}
          form={this.props.form}
        >
          {this.state.text}{this.props.icon && this.props.icon }
        </button>
      );
  }
}

export default MainButton;
